import script from "./Review.vue?vue&type=script&setup=true&lang=ts"
export * from "./Review.vue?vue&type=script&setup=true&lang=ts"

import "./Review.vue?vue&type=style&index=0&id=1def4d49&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1def4d49"]])

export default __exports__